import {apolloPlatformAxiosInstance as axiosInstance} from './apolloPlatformAxiosInstance';

/**
 * News API
 */

export const apiGetNews = (parentIds: number[] | number | null, offset: number, limit: number) => {
  const params: any = {offset, limit};
  if (parentIds !== null) {
    if (Array.isArray(parentIds)) {
      params.parentIds = parentIds.join(',');
    } else {
      params.parentIds = String(parentIds);
    }
  }
  return axiosInstance.get('/cms/news/', {params});
};

export const apiGetNewsItem = (newsPageId: number) => {
  return axiosInstance.get(`/cms/news/${newsPageId}/`);
};

export const apiGetNewsIndexList = () => {
  return axiosInstance.get('/cms/news_index/');
};
